import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ListOrdersParams, Order, OrdersService } from 'src/app/core/orders.service';
import { ERROR_ORDER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-orders-data',
  templateUrl: './orders-data.component.html',
  styleUrls: ['./orders-data.component.scss'],
})
export class OrdersDataComponent {
  @ViewChild('orders_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  orders?: Order[];
  cursor: string | null = null;
  total?: number;
  filters?: ListOrdersParams;

  constructor(private orders_service: OrdersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.orders = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = undefined;
    this.listOrders();
  }

  onRefresh(): void {
    this.orders = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = undefined;
    this.listOrders();
  }

  onFilter(filters?: ListOrdersParams): void {
    this.orders = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = filters;
    this.listOrders(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listOrders(this.filters, true);
  }

  listOrders(filters?: ListOrdersParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_orders_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.orders_service.listOrders(list_orders_params).subscribe({
      next: response => {
        const orders = response.data.data;
        this.orders = (this.orders ? this.orders : []).concat(orders);
        this.cursor = response.data.cursor;
        if (list_orders_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_ORDER_NOT_FOUND) {
          this.orders = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
